import { defineStore } from 'pinia'

export const useIndustryStore = defineStore('IndustryStore', {
  state: () => {
    return {
      industries: [],
    }
  },
  actions: {
    fetchIndustries() {
      return this.api.getIndustries().then((response) => {
        this.industries = response.data.industries
      })
    },
  },
})
